import Vue from 'vue'
import VueRouter from 'vue-router'
import store     from '@/store/index.js'
import routes    from "@/router/routes";

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach( ( to, from, next ) => {

	//AUTHENTICATION GUARD
	if( to.meta.auth.required && !store.getters.isSignedIn ) {
		sessionStorage.setItem('pre-auth-request-url', to.fullPath)
		next( '/auth/sign-in' );
	}
	else {
		next();
	}
} );

export default router
